var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequiringFollowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FFB762",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.33331C10.32 7.33331 7.33331 10.32 7.33331 14C7.33331 17.68 10.32 20.6666 14 20.6666C17.68 20.6666 20.6666 17.68 20.6666 14C20.6666 10.32 17.68 7.33331 14 7.33331ZM14 11.8333C13.7266 11.8333 13.5 11.6066 13.5 11.3333C13.5 11.06 13.7266 10.8333 14 10.8333C15.7466 10.8333 17.1666 12.2533 17.1666 14C17.1666 15.7466 15.7466 17.1666 14 17.1666C13.7266 17.1666 13.5 16.94 13.5 16.6666C13.5 16.3933 13.7266 16.1666 14 16.1666C15.1933 16.1666 16.1666 15.1933 16.1666 14C16.1666 12.8066 15.1933 11.8333 14 11.8333ZM14 19.1666C11.1533 19.1666 8.83331 16.8466 8.83331 14C8.83331 13.7266 9.05998 13.5 9.33331 13.5C9.60665 13.5 9.83331 13.7266 9.83331 14C9.83331 16.3 11.7 18.1666 14 18.1666C16.3 18.1666 18.1666 16.3 18.1666 14C18.1666 11.7 16.3 9.83331 14 9.83331C13.7266 9.83331 13.5 9.60665 13.5 9.33331C13.5 9.05998 13.7266 8.83331 14 8.83331C16.8466 8.83331 19.1666 11.1533 19.1666 14C19.1666 16.8466 16.8466 19.1666 14 19.1666Z",
    fill: "#FFB762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequiringFollowUp);
export default __webpack_public_path__ + "static/media/RequiringFollowUp.5185df4eb7d5b1125bd8e1718a8c1cbc.svg";
export { ForwardRef as ReactComponent };